import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WorkTypesState } from './work-types.state';

export const selectWorkTypesState = createFeatureSelector<WorkTypesState>('adminWorkTypes');

export const selectAllWorkTypes = createSelector(
  selectWorkTypesState,
  (state) => state.workTypes,
);

export const selectWorkTypesLoading = createSelector(
  selectWorkTypesState,
  (state) => state.loading,
);

export const selectWorkTypesError = createSelector(
  selectWorkTypesState,
  (state) => state.error,
);

export const selectWorkTypesPagination = createSelector(
  selectWorkTypesState,
  (state) => state.pagination,
);
